import React, { useContext, useEffect, useState } from "react";
import { Button, Grid, Layout, Tooltip } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { LogoWhite, JetLogo } from "@IMAGES";
import { NavLink } from "react-router-dom";
import HJMenu from "./menu";
import "./index.scss";
import { AiOutlinePlus } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { useAuthority } from "@HOOKS";
import { AuthContext, AppContext } from "@CONTEXTS";

const { Sider } = Layout;
const { useBreakpoint } = Grid;

const SITE_LAYOUT_HOVER_CLASS = "site-layout--hover-expanded";

const setSiteLayoutHoverExpanded = (expanded) => {
  document
    .querySelector(".site-layout")
    ?.classList.toggle(SITE_LAYOUT_HOVER_CLASS, expanded);
};

const Sidebar = () => {
  const {
    info: { dashboardDisabled },
  } = useContext(AuthContext);
  const { isCollapsed, setIsCollapsed } = useContext(AppContext);
  const history = useHistory();
  const [hoverExpanded, setHoverExpanded] = useState(false);
  const screens = useBreakpoint();
  const isMobileOrTablet = screens.md === false;
  // Hover expands locally; content margin is synced via CSS class (no AppContext)
  const isVisuallyCollapsed = isCollapsed && !hoverExpanded;

  useEffect(() => {
    return () => setSiteLayoutHoverExpanded(false);
  }, []);

  const handleMouseEnter = () => {
    if (isMobileOrTablet || !isCollapsed) return;
    setHoverExpanded(true);
    setSiteLayoutHoverExpanded(true);
  };

  const handleMouseLeave = () => {
    if (isMobileOrTablet || !hoverExpanded) return;
    setHoverExpanded(false);
    setSiteLayoutHoverExpanded(false);
  };

  const toggleCollapse = () => {
    setHoverExpanded(false);
    setSiteLayoutHoverExpanded(false);
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Sider
      className="app-sidebar"
      theme="dark"
      width={250}
      collapsedWidth={80}
      collapsed={isVisuallyCollapsed}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        left: 0,
        zIndex: 5,
      }}
    >
      <div
        className={
          isVisuallyCollapsed ? "sidebar-header-collapsed" : "sidebar-header"
        }
      >
        {isMobileOrTablet && (
          <Button
            type="text"
            className="sidebar-collapse-btn"
            icon={
              isVisuallyCollapsed ? (
                <MenuUnfoldOutlined style={{ fontSize: "40px" }} />
              ) : (
                <MenuFoldOutlined style={{ fontSize: "40px" }} />
              )
            }
            onClick={toggleCollapse}
            // size="large"
          />
        )}
        <div className="logo">
          <NavLink
            to={dashboardDisabled ? "/admin/company-info" : "/dashboard"}
            activeClassName="active"
          >
            <img
              src={isVisuallyCollapsed ? JetLogo : LogoWhite}
              alt="hepsiJet"
            />
          </NavLink>
        </div>
      </div>
      {useAuthority("CREATE_DELIVERY") && (
        <div
          style={{
            margin: isVisuallyCollapsed
              ? "25px 10px 10px"
              : "25px 15px 10px 15px",
          }}
        >
          <Tooltip
            title={isVisuallyCollapsed ? "Yeni Gönderi Oluştur" : null}
            placement="right"
          >
            <span className="create-delivery-btn-wrapper">
              <Button
                type="primary"
                block
                icon={<AiOutlinePlus />}
                onClick={() => history.push("/create/delivery")}
              >
                {!isVisuallyCollapsed && "Yeni Gönderi Oluştur"}
              </Button>
            </span>
          </Tooltip>
        </div>
      )}
      <HJMenu />
    </Sider>
  );
};

export default Sidebar;
